import React, { useState } from "react";
import "./index.less";
import MenusDirList from "../MenusDirList";
import { MenuItem } from "@/types/base";

interface MenusCollProps {
  data: MenuItem;
  selectMenuId: any;
  tier: any;
  dirNameClass: any;
  onMenuClick:(...args:any[])=>void
}

const prefix = "MenusColl";

/**
 * 菜单列表-主菜单
 * @param props
 * @returns
 */
const MenusColl: React.FC<MenusCollProps> = (props) => {
  const { data, selectMenuId, tier, dirNameClass,onMenuClick } = props;
  
  const isSelect=data.id==selectMenuId;

  const hasChildren = data.children && data.children?.length > 0;
  const maxHeight =data.children?data.children?.length * 60 :0;
  const initMenuShow=true;
  const [menuShow, setMenuShow] = useState(initMenuShow);
  const changeCollMenu = () => {
    if(hasChildren){
      setMenuShow((value) => !value);
    }else{
      onMenuClick(data)
    }
    
  };
  return (
    <>
      <div  className={`menus-coll ${isSelect?"is-select":''}`} onClick={changeCollMenu}>
        <div className={"menus-coll-header"+` ${dirNameClass}`} >
            <div className="menus-coll-header-icon">{data.iconUrl&& <img src={data.iconUrl} alt="" />}</div>
            {data.title}

        </div>
        {
          hasChildren && <div className="menus-coll-icon flex-center">
          <img src={require('@/assets/images/support/arrow-icon.png')} className={menuShow ? "is-rotate is-transition" : "is-transition"} alt="" />
        </div>
        }
      </div>

      {
       hasChildren &&<div className="menus-coll-list is-transition" style={{ maxHeight: menuShow ? maxHeight/10+'rem' : "0" }}>
        {
          data.children?.map((item: MenuItem, index: number) => {
            return <div key={item.key}>
              <MenusColl 
                  onMenuClick={onMenuClick}
                  dirNameClass={"dir-text"} 
                  tier={tier} 
                  data={item} 
                  selectMenuId={selectMenuId}></MenusColl>
            </div>
          })
        }
      </div>
      }
    </>
  );
};

export default MenusColl;
